module.exports = __webpack_public_path__ + "img/kxpj.8ec21a58.png";